
import { ILoginData } from "../Interfaces/RequestsData"
import { ICourseDetailsResponse, ICoursesManagementList, IDepartmentEmps, ILoginResponseData, InstitutionData, IResponse, ISpecializationLevelResponse,  MarketerProfileDetails,  PrintedCertificates,  TraineeProfile, TraineesPrief } from "../Interfaces/ResponsesData"
import { DeviceData } from "../Models/Device"
import { SalaryDetails, SalaryItems, TraineeTransaction } from "../Models/Marketer"
import { clientsSheetItem, ClientsWithRemainingMoney, TraineePersonalInfo } from "../Models/Trainee"
import { AxiosRequest } from "./AxiosHandler"
import { Certify } from "../Models/Course"
import { CourseCertificate, CourseCertificatePrint, PathCertificate, PathCertificatePrint } from "../Models/Certificates"
import { Account, AccountsSheetItem, Currency } from "../Models/Accounts"
import { Shipment } from "../Models/Shipment"
import { TransactionsSheetItem } from "../Models/Transactions"

export class ApiRequest{
    //pathes
    private static loginURL = 'login'
    private static refreshLoginURL = 'refreshLogin'
    private static rememberLoginURL = 'rememberLogin'
    private static getRolesURL = 'roles'
    private static addEmployeeAccountURL = 'addNewEmployeeAccount'
    private static employeesListURL = 'employeesList'
    private static empListsURL = 'employees'
    private static passwordResetURL = 'passwordReset'
    private static deleteUserURL = 'deleteUser'
    private static editUserURL = 'editUser'
    private static updatePermissionURL = 'updatePermission'
    private static addMarketerURL = 'addMarketer'
    private static marketersPriefListURL = 'marketersPriefList'
    private static getSpecializationsListURL = 'getSpecializationsList'
    private static getCourseManagementListsURL = 'getCourseManagementLists'
    private static deleteSpecializationURL = 'deleteSpecialization' 
    private static deleteLevelURL = 'deleteLevel'
    private static deleteCourseURL = 'deleteCourse'   
    private static addSpecializationURL = 'addSpecialization'  
    private static addLevelURL = 'addLevel'  
    private static addCourseURL = 'addCourse'  
    private static getLevelSpecializationInfoURL = 'getLevelSpecializationInfo'
    private static attachCourseURL = 'attachCourse'
    private static detatchCourseURL = 'detatchCourse'
    private static changeSpecializationLevelCodeURL = 'changeSpecializationLevelCode'
    private static changeSpecializationLevelPriceURL = 'changeSpecializationLevelPrice'
    private static allCoursesURL = 'allCourses'
    private static getCourseDetailsURL = 'getCourseDetails'
    private static editPeriodURL = 'editPeriod'
    private static deletePeriodURL = 'deletePeriod'
    private static createPeriodURL = 'createPeriod'
    private static marketersListURL = 'marketersList'
    private static createTraineeURL = 'createTrainee'
    private static getAccountsAndLevelSpecializationsURL = 'getAccountsAndLevelSpecializations'
    private static getAccountsURL = 'getAccounts'
    private static getCurrenciesURL = 'getCurrencies'
    private static getCurrenciesAndBankAccountsURL = 'getCurrenciesAndBankAccounts'
    private static createAccoutURL = 'createAccout'
    private static updateAccoutURL = 'updateAccount'
    private static createSubscriptionURL ='createSubscription'
    private static traineesURL = 'trainees' 
    private static traineeProfileURL = 'traineeProfile'
    private static addTransactionURL = 'addTransaction'
    private static editTransactionURL = 'editTransaction'
    private static deleteTransactionURL = 'deleteTransaction'
    private static traineePeriodURL = 'traineePeriod'
    private static certifyCourseURL = 'certifyCourse'
    private static changeCurrenciesPricesURL = 'changeCurrenciesPrices'
    private static getMarketerFinanceURL = 'getMarketerFinance'
    private static confirmSalaryURL = 'confirmSalary'
    private static GetMarketersSalaryConfirmationLisURL = 'GetMarketersSalaryConfirmationLis'
    private static waitingSalariesListURL = 'waitingSalariesList'
    private static acceptSalaryURL = 'acceptSalary'
    private static marketerTransactionsListURL = 'marketerTransactionsList'
    private static getAllDevicesURL = 'getAllDevices'
    private static createDeviceURL = 'createDevice'
    private static removeDeviceURL = 'removeDevice'
    private static deactivateDeviceURL = 'deactivateDevice'
    private static activateDeviceURL = 'activateDevice'
    private static checkDeviceURL = 'checkDevice'
    private static traineePersonalInfoURL = 'traineePersonalInfo'
    private static editTraineeInfoURL = 'editTraineeInfo'
    private static editMarketerInfoURl = 'editMarketerInfo'
    private static getMarketerInfoURL = 'getMarketerInfo'
    private static printingListURL = 'printingList'
    private static getMoreCoursesPrintingListURL ='getMoreCoursesPrintingList'
    private static getMorePathsPrintingListURL ='getMorePathsPrintingList'
    private static getAllInstitutionsDataURL = 'getAllInstitutionsData'
    private static addInstitutionURL = 'addInstitution'
    private static deleteInistitutionURL = 'deleteInistitution'
    private static attachCourseToInstitutionURL = 'attachCourseToInstitution'
    private static detachCourseFromInstitutionURL = 'detachCourseFromInstitution'
    private static attachLevelSpecializationToInstitutionURL = 'attachLevelSpecializationToInstitution'
    private static detachLevelSpecializationFromInstitutionURL = 'detachLevelSpecializationFromInstitution'
    private static marketerSalariesListURL = 'marketerSalariesList'
    private static createShippingNumberURL = 'createShippingNumber'
    private static activateShippingNumberURL = 'activateShippingNumber'
    private static deleteShippingNumberURL = 'deleteShippingNumber'
    private static confirmPrintingCourseURL = 'confirmPrintingCourse'
    private static confirmPrintingPathURL = 'confirmPrintingPath'
    private static getAllPrintedURL = 'getAllPrinted'
    private static getMorePrintedPathsURL = 'getMorePrintedPaths'
    private static getMorePrintedCoursesURL = 'getMorePrintedCourses'
    private static getAccountantRecordsURL = 'getAccountantRecords'
    private static addAccountantRecordURL = 'addAccountantRecord'
    private static getReportsURL = 'getReports'
    private static getConstantsURL = 'getConstants'
    private static editConstantsURL = 'editConstants' 
    private static clientsWithRemainingMoneyURL = 'clientsWithRemainingMoney' 
    private static getShipmentsURL = 'getShipments' 
    private static certifyURL = 'certify'
    private static editeShippingNumberNotesURL ='editeShippingNumberNotes'
    private static clientSheetURL ='clientSheet'
    private static transactionsSheetURL ='transactionsSheet'
    private static accountsSheetURL ='accountsSheet'
    private static getAdminsURL = 'getAdmins'

    //auth 
    public static async Login(loginData:ILoginData){
        return await AxiosRequest.postlogin(this.loginURL , loginData)
    }
    public static async RefreshLogin(token:string){
        return await AxiosRequest.postAuth(this.refreshLoginURL,token)
    }
    public static async RememberLogin(token:string){
        return await AxiosRequest.postAuth(this.rememberLoginURL,token )
    }

    public static async authTest(){
        return await AxiosRequest.postClear<{token:string}>('authTest')
    }

    //general
    public static async getRoles(){
        return await AxiosRequest.get<{id:string , role:string}[]>(this.getRolesURL)
    }
    public static async marketersPriefList(status:'active'|'inActive',search?:string){
        return await AxiosRequest.get<{id:string , name:string , commission:string , trainees_count:string, status:'active'|'inActive'}[]>(this.marketersPriefListURL+('?status='+status)+(search?'&search='+search:''))
    }
    public static async getSpecializationsList(){
        return await AxiosRequest.get<{id:string , specialization:string}[]>(this.getSpecializationsListURL)
    }
    public static async getCourseManagementLists(){
        return await AxiosRequest.get<ICoursesManagementList>(this.getCourseManagementListsURL)
    }
    public static async getLevelSpecializationInfo(specialization:string , level:string ){
        return await AxiosRequest.post<{specialization:string , level:string }, ISpecializationLevelResponse>(this.getLevelSpecializationInfoURL, {specialization:specialization , level:level})
    }
    public static async marketersList(){
        return await AxiosRequest.get<{id:string , name:string}[]>(this.marketersListURL)
    }
    public static async getAccountsAndLevelSpecializations(id:string){
        return await AxiosRequest.get<{levelSpecializations:{id:string , price:string , name:string }[] ,accounts:{id:string , name:string , banck_account_id:string , currency:{id:string , account:string , arabic_currency_name:string , english_currency_name:string , price:number } }[]}>(this.getAccountsAndLevelSpecializationsURL+"?id="+id)
    }
    public static async getAccounts(){
        return await AxiosRequest.get<{id:string , name:string , banck_account_id:string , currency:{id:string , account:string , arabic_currency_name:string , english_currency_name:string , price:number } }[]>(this.getAccountsURL)
    }
    public static async getCurrenciesAndBankAccounts(){
        return await AxiosRequest.get<{currencies:Currency[] , accounts:Account[]}>(this.getCurrenciesAndBankAccountsURL)
    }
    public static async createAccout(name:string  , currency_id: string){
        return await AxiosRequest.post<{name:string , currency_id:string} , Account>(this.createAccoutURL ,{name:name , currency_id:currency_id})
    }
    public static async updateAccount( id:string , name:string  , currency_id: string){
        return await AxiosRequest.post<{id:string ,name:string , currency_id:string} , Account>(this.updateAccoutURL ,{id:id , name:name , currency_id:currency_id})
    }
    public static async trainees(data:{search?:string,id?:string}){
        return await AxiosRequest.get<TraineesPrief[]>(this.traineesURL+'?search='+(data.search||'')+'&id='+(data.id||''))
    }
    public static async getCurrences(){
        return await AxiosRequest.get<{id:string , account:string , arabic_currency_name:string , english_currency_name:string , price:string ,status:'active'|'inActive'}[]>(this.getCurrenciesURL)
    }
    public static async getMarketerFinance(id:string){
        return await AxiosRequest.get<MarketerProfileDetails>(this.getMarketerFinanceURL+'?id='+id)
    }
    public static async GetMarketersSalaryConfirmationLis(){
        return await AxiosRequest.get<{marketer_id:string , name: string , total_sales:string}[]>(this.GetMarketersSalaryConfirmationLisURL)
    }
    public static async waitingSalariesList(){
        return await AxiosRequest.get<SalaryDetails[]>(this.waitingSalariesListURL)
    }
    public static async marketerTransactionsList(id:string, status?:string , from?:string , to?:string , search?:string){
        return await AxiosRequest.get<TraineeTransaction[]>(this.marketerTransactionsListURL+'?id='+id+(status?('&status='+status):'')+(from?('&from='+from):'')+(to?('&to='+to):'')+(search?('&search='+search):'') )
    }
    public static async activateDevice(password:string){
        return await AxiosRequest.postActivateDevice(this.activateDeviceURL ,{password:password})
    }
    public static async checkDevice(token:string){
        return await AxiosRequest.postCheckDevice(this.checkDeviceURL ,{token:token})
    }
    public static async traineePersonalInfo(id:string){
        return await AxiosRequest.get<{data:TraineePersonalInfo , marketers:{label:string , value:string}[]}>(this.traineePersonalInfoURL+'?id='+id)
    }
    public static async EditTraineeInfo(data:FormData){
        return await AxiosRequest.statusFilesPost<FormData>(this.editTraineeInfoURL ,  data)
    }
    public static async editMarketerInfo(data:{id:string , name:string , email:string|null  , dial_code:string , mobile:string , bank_account:string|null  , commission:string } ){
        return await AxiosRequest.statusPost<{id:string , name:string , email:string|null  , dial_code:string , mobile:string , bank_account:string|null  , commission:string } >(this.editMarketerInfoURl , data)
    }
    public static async getMarketerInfo(id:string){
        return await AxiosRequest.get<{ name:string , email:string|null  , dial_code:string , mobile:string , bank_account:string|null  , commission:string }>(this.getMarketerInfoURL+'?id='+id)
    }
    public static async getAllInstitutionsData(){
        return await AxiosRequest.get<InstitutionData>(this.getAllInstitutionsDataURL)
    }
    public static async addInstitution(name:string){
        return await AxiosRequest.statusPost<{name:string}>(this.addInstitutionURL,{name:name})
    }
    public static async deleteInistitution(id:string){
        return await AxiosRequest.statusPost<{id:string}>(this.deleteInistitutionURL, {id:id})
    }
    public static async attachCourseToInstitution(id:string, course_id :string){
        return await AxiosRequest.statusPost<{id:string , course_id:string}>(this.attachCourseToInstitutionURL , {id:id,course_id:course_id})
    }
    public static async detachCourseFromInstitution(id:string , course_id:string){
        return await AxiosRequest.statusPost<{id:string , course_id:string}>(this.detachCourseFromInstitutionURL , {id:id , course_id:course_id})
    }
    public static async attachLevelSpecializationToInstitution(id:string, level_specialization_id :string){
        return await AxiosRequest.statusPost<{id:string , level_specialization_id:string}>(this.attachLevelSpecializationToInstitutionURL , {id:id,level_specialization_id:level_specialization_id})
    }
    public static async detachLevelSpecializationFromInstitution(id:string , level_specialization_id:string){
        return await AxiosRequest.statusPost<{id:string , level_specialization_id:string}>(this.detachLevelSpecializationFromInstitutionURL , {id:id , level_specialization_id:level_specialization_id})
    }
    public static async marketerSalariesList(id:string, from:string='0'){
        return await AxiosRequest.get<SalaryDetails[]>(this.marketerSalariesListURL+'?id='+id +'&from='+from)
    }
    public static async clientsWithRemainingMoney(id:string , search:string = ''){
        return await AxiosRequest.get<ClientsWithRemainingMoney[]>(this.clientsWithRemainingMoneyURL+'?id='+id+'&search='+search )
    }
    public static async getShipments(id:string , search:string = '' , isDone:''|'done'|'waiting' = ''){
        return await AxiosRequest.get<Shipment[]>(this.getShipmentsURL+'?id='+id+'&search='+search + '&isDone='+isDone )
    }
    public static async getAdmins(){
        return AxiosRequest.get<{id:string , name:string}[]>(this.getAdminsURL)
    }

    //admin
    public static async addEmployeeAccount(data:{name:string , role:string , password:string}){
        return await AxiosRequest.statusPost<{name:string , role:string , password:string}>(this.addEmployeeAccountURL,data)
    }
    public static async getEmpsList(){
        return await AxiosRequest.get<{id:string , name:string , employee_key:string , role:string }[]>(this.employeesListURL)
    }
    public static async getEmpLists(){
        return await AxiosRequest.get<IDepartmentEmps[]>(this.empListsURL)
    }
    public static async passwordReset(id:string ){
        return await AxiosRequest.statusPost<{id:string }>(this.passwordResetURL , {id:id})
    }
    public static async deleteUser(id:string){
        return await AxiosRequest.statusPost<{id:string}>(this.deleteUserURL , {id:id} )
    }
    public static async editUser(id:string , name:string , email:string , password:string ,role_id:string){
        return await AxiosRequest.statusPost<{id:string , name:string , email:string , password:string ,role_id:string}>(this.editUserURL , {id:id , name:name , email:email , password:password ,role_id:role_id} )
    }
    public static async updatePermission(role_id:string , permission_id:string , value:'enable'|'disable'){
        return await AxiosRequest.statusPost<{role_id:string , permission_id:string , value:'enable'|'disable'}>(this.updatePermissionURL , {role_id:role_id , permission_id:permission_id , value:value})
    }
    public static async AddNewMarketer(data:{name:string , email:string , dial_code:string , mobile:string , bank_account:string ,  commission:string } ){
        return await AxiosRequest.statusPost<{name:string , email:string , dial_code:string , mobile:string , bank_account:string ,  commission:string }>(this.addMarketerURL , data)
    }
    public static async deleteItem(id:string, dataType:'التخصص'|'المستوى'|'الكورس'|'الجهة'){
        switch(dataType){
            case "التخصص":return await AxiosRequest.statusPost<{id:string}>(this.deleteSpecializationURL , {id:id})
            case "المستوى":return await AxiosRequest.statusPost<{id:string}>(this.deleteLevelURL , {id:id})
            case "الكورس":return await AxiosRequest.statusPost<{id:string}>(this.deleteCourseURL , {id:id})
            case "الجهة":return await AxiosRequest.statusPost<{id:string}>(this.deleteInistitutionURL , {id:id})

            default: return null;
        }
    }
    public static async addItem(value:string, dataType:'التخصص'|'المستوى'|'الكورس'|'الجهة'){
        switch(dataType){
            case "التخصص":return await AxiosRequest.post<{value:string},{id:string , value:string}>(this.addSpecializationURL , {value:value})
            case "المستوى":return await AxiosRequest.post<{value:string},{id:string , value:string}>(this.addLevelURL , {value:value})
            case "الكورس":return await AxiosRequest.post<{value:string},{id:string , value:string}>(this.addCourseURL , {value:value})
            case "الجهة":return await AxiosRequest.post<{value:string},{id:string , value:string}>(this.addInstitutionURL , {value:value})
            default: return null;
        }
    }
    public static async attachCourseToSpecializationLevel(id:string , courseId:string){
        return await AxiosRequest.statusPost<{id:string , course_id:string}>(this.attachCourseURL,{id:id, course_id:courseId})
    }
    public static async allCourses(){
        return await AxiosRequest.get<{id:string , course:string}[]>(this.allCoursesURL)
    }
    public static async detatchCourseToSpecializationLevel(id:string , courseId:string){
        return await AxiosRequest.statusPost<{id:string , course_id:string}>(this.detatchCourseURL,{id:id, course_id:courseId})
    }
    public static async changeSpecializationLevelCode(id:string , code:string){
        return await AxiosRequest.statusPost<{id:string , code:string}>(this.changeSpecializationLevelCodeURL,{id:id, code:code})
    }
    public static async changeSpecializationLevelPrice(id:string , price:string){
        return await AxiosRequest.statusPost<{id:string , price:string}>(this.changeSpecializationLevelPriceURL,{id:id, price:price})
    }
    public static async getCourseDetails(id:string ){
        return await AxiosRequest.post<{id:string } , ICourseDetailsResponse>(this.getCourseDetailsURL,{id:id})
    }
    public static async editPeriod(id:string , start?:string , end?:string , hours?:string ){
        return await AxiosRequest.statusPost<{id:string , start?:string , end?:string , hours?:string}>(this.editPeriodURL,{id:id , start:start , end:end , hours:hours})
    }
    public static async deletePeriod(id:string){
        return await AxiosRequest.statusPost<{id:string}>(this.deletePeriodURL,{id:id})
    }
    public static async createPeriod(course_id:string , start :string , end: string , hours:string){
        return await AxiosRequest.post<{course_id:string , start :string , end: string , hours:string},{id:string}>(this.createPeriodURL , {course_id:course_id , start :start , end: end , hours:hours})
    }
    public static async changeCurrenciesPrices(data:{id:string , account:string, arabic_currency_name:string , english_currency_name:string , price:string}){
        return await AxiosRequest.post<{id:string , account:string, arabic_currency_name:string , english_currency_name:string , price:string} , string>(this.changeCurrenciesPricesURL , data)
    }
    public static async getAllDevices(){
        return await AxiosRequest.get<DeviceData[]>(this.getAllDevicesURL)
    }
    public static async createDevice(name:string){
        return await AxiosRequest.statusPost<{name:string}>(this.createDeviceURL,{name:name})
    }
    public static async removeDevice(id:string){
        return await AxiosRequest.statusPost<{id:string}>(this.removeDeviceURL , {id:id})
    }
    public static async deactivateDevice(id:string){
        return await AxiosRequest.statusPost<{id:string}>(this.deactivateDeviceURL, {id:id})
    }
    public static async printingList(){
        return await AxiosRequest.get<{courses:CourseCertificate[] , pathes:PathCertificate[]}>(this.printingListURL)
    }
    public static async certify(){
        return await AxiosRequest.statusPost<null>(this.certifyURL,null)
    }
    public static async getMorePathsPrintingList(data:{id?:string , search?:string}){
        return await AxiosRequest.get<PathCertificate[]>(this.getMorePathsPrintingListURL+'?id='+(data.id||'')+'&search='+(data.search||''))
    }
    public static async getMoreCoursesPrintingList(data:{id?:string , search?:string}){
        return await AxiosRequest.get<CourseCertificate[]>(this.getMoreCoursesPrintingListURL+'?id='+(data.id||'')+'&search='+(data.search||''))
    }
    public static async getAllPrinted(){
        return await AxiosRequest.get<PrintedCertificates>(this.getAllPrintedURL)
    }
    public static async getAccountantRecords(props:{from?:string , to?:string,id?:string , search?:string , type?:string , user_id?:string}){
        return await AxiosRequest.get<{items:{id:string , value:string , direction:string, img:string , notes:string , created_at:string , user:{id:string , name:string}}[],income:number , outgoing:number ,total:number}>(this.getAccountantRecordsURL+'?from='+(props.from||'')+'&to='+(props.to||'')+'&id='+(props.id||'')+'&search='+(props.search||'')+'&type='+(props.type||'')+'&user_id='+(props.user_id||''))
    }
    public static async addAccountantRecord(data:FormData){
        return await AxiosRequest.statusPost<FormData>(this.addAccountantRecordURL , data)
    }
    public static async getReports(props:{from?:string , to?:string,id?:string}){
        return await AxiosRequest.get<{id:string , device_name:string , employee_key:string , employee_name:string ,log:string, created_at:string}[]>(this.getReportsURL+'?from='+(props.from||'')+'&to='+(props.to||'')+'&id='+(props.id||''))
    }
    public static async getConstants(){
        return await AxiosRequest.get<{target:string , cuts:string , bonuses:string}>(this.getConstantsURL)
    }
    public static async editConstants(data:{target:string ,cuts:string , bounses:string }){
        return await AxiosRequest.statusPost<{target:string ,cuts:string , bounses:string }>(this.editConstantsURL , data)
    }
    public static async clientsSheet(data:{search?:string ,from?:string , to?:string }){
        return await AxiosRequest.get<clientsSheetItem[]>(this.clientSheetURL+'?search='+(data.search||'')+'&from='+(data.from||'')+'&to='+(data.to||''))
    }
    public static async transactionsSheet(data:{search?:string ,from?:string , to?:string , status?:string, type?:string }){
        return await AxiosRequest.get<{data:TransactionsSheetItem[],total:string}>(this.transactionsSheetURL+'?search='+(data.search||'')+'&from='+(data.from||'')+'&to='+(data.to||'')+'&status='+(data.status||'')+'&type='+(data.type||''))
    }
    public static async accountsSheet(data:{from?:string , to?:string }){
        return await AxiosRequest.get<AccountsSheetItem[]>(this.accountsSheetURL+'?from='+(data.from||'')+'&to='+(data.to||''))
    }

    //Trainees
    public static async createTrainee(data:FormData){
        return await AxiosRequest.filesPost<FormData , {id:string,name:string}>(this.createTraineeURL , data)
    }
    public static async traineeProfile(id:string){
        return await AxiosRequest.get<TraineeProfile>(this.traineeProfileURL+"?id="+id)
    }
    public static async createShippingNumber(id:string , number:string , notes:string , status: string){
        return await AxiosRequest.statusPost<{id:string , number:string , notes:string , status: string}>(this.createShippingNumberURL,{id:id , number:number , notes:notes , status:status})
    }
    public static async activateShippingNumber(id:string){
        return await AxiosRequest.statusPost<{id:string}>(this.activateShippingNumberURL , {id:id})
    }
    public static async deleteShippingNumber(id:string){
        return await AxiosRequest.statusPost<{id:string}>(this.deleteShippingNumberURL , {id:id})
    }

    //subscriptions
    public static async createSubscription(data:FormData){
        return await AxiosRequest.statusFilesPost<FormData>(this.createSubscriptionURL , data)
    }
    public static async addTransaction(data:FormData){
        return await AxiosRequest.statusFilesPost<FormData>(this.addTransactionURL , data)
    }
    public static async editTransaction(data:FormData){
        return await AxiosRequest.statusFilesPost<FormData>(this.editTransactionURL , data)
    }
    public static async deleteTransaction(id:string){
        return await AxiosRequest.statusPost<{id:string}>(this.deleteTransactionURL , {id:id})
    }
    public static async traineePeriod(course_id:string, period_id:string , level_specialization_trainee_id:string , trainee_id:string){
        return await AxiosRequest.statusPost<{course_id:string, period_id:string , level_specialization_trainee_id:string , trainee_id:string}>(this.traineePeriodURL , {course_id:course_id, period_id:period_id, level_specialization_trainee_id:level_specialization_trainee_id , trainee_id:trainee_id})
    }
    public static async certifyCourse(id:string , course_id:string , level_specialization_id:string , period_id:string, level_specialization_trainee_id:string ){
        return await AxiosRequest.statusPost<{id:string , course_id:string , level_specialization_id:string , period_id:string, level_specialization_trainee_id:string }>(this.certifyCourseURL , {id:id , course_id:course_id , level_specialization_id:level_specialization_id , period_id:period_id , level_specialization_trainee_id:level_specialization_trainee_id })
    }
    public static async editeShippingNumberNotes(id:string , notes:string ){
        return await AxiosRequest.statusPost<{id:string , notes:string}>(this.editeShippingNumberNotesURL , {id:id , notes:notes })
    }

    //salaries
    public static async confirmSalary(data:SalaryItems|{id:string , target:string , cut:string , bounus:string , notes:string}){
        return await AxiosRequest.statusPost<{id:string , target:string , cut:string , bounus:string , notes:string}>(this.confirmSalaryURL , {id:data.id , target:data.target , cut:data.cut , bounus: data.bounus , notes:data.notes })
    }
    public static async acceptSalary(id:string){
        return await AxiosRequest.statusPost<{id:string}>(this.acceptSalaryURL , {id:id})
    }
    
    //printing 
    public static async confirmPrintingCourse(id:string , name:string ,specialization:string ,trainee_id:string , trainee_name:string, trainee_english_name:string , start :string , end:string , hours:string, institution:string ,code:string , notes:string){
        return await AxiosRequest.statusPost<{id:string , trainee_id:string , course:string , specialization:string, trainee_name:string, trainee_english_name:string  , start:string , end:string , hours:string , code:string , institution:string , notes:string}>(this.confirmPrintingCourseURL , {id:id , trainee_id:trainee_id , course:name , specialization:specialization , trainee_name:trainee_name, trainee_english_name:trainee_english_name  , start:start , end:end , hours:hours , code:code , institution:institution , notes:notes})
    }
    public static async confirmPrintingPath(id:string , path:string ,trainee_id:string , trainee_name:string, trainee_english_name:string , start :string , end:string , hours:string, institution:string ,code:string ,  notes:string , verification:string){
        return await AxiosRequest.statusPost<{id:string , trainee_id:string , path:string, trainee_name:string , trainee_english_name:string , start:string , end:string , hours:string , code:string , institution:string , notes:string , verification:string}>(this.confirmPrintingPathURL , {id:id , trainee_id:trainee_id , path:path, trainee_name:trainee_name , trainee_english_name:trainee_english_name , start:start , end:end , hours:hours , code:code , institution:institution , notes:notes , verification:verification})
    }
    public static async getMorePrintedPaths(id?:string,search?:string){
        return await AxiosRequest.get<PathCertificatePrint[]>(this.getMorePrintedPathsURL+'?id='+(id||'')+'&search='+(search||''))
    }
    public static async getMorePrintedCourses(id?:string,search?:string){
        return await AxiosRequest.get<CourseCertificatePrint[]>(this.getMorePrintedCoursesURL+'?id='+(id||'')+'&search='+(search||''))
    }

}